// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.report.RentalManagerExternalReportWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerExternalReportWebApiHandler_spamInquiry,
  RentalManagerExternalReportWebApiHandler_spamInquiryForConversation,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface SpamInquiryParams {
  comment?: string;
  controlHash: string;
  inquiryId: number;
  reporterEmail?: string;
}
interface SpamInquiryForConversationParams {
  comment?: string;
  conversationId: number;
  messageId: number;
  reporterEmail: string;
}

export interface RentalManagerExternalReportWebApiHandler_spamInquiry_Args {
  getParams: SpamInquiryParams;
}

export type RentalManagerExternalReportWebApiHandler_spamInquiry_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerExternalReportWebApiHandler_spamInquiry_Args
>;

/**
 * Report an inquiry as spam using inquiryId for non authenticated users
 */
export const useRentalManagerExternalReportWebApiHandler_spamInquiry = ({
  httpClient,
  ...options
}: Omit<RentalManagerExternalReportWebApiHandler_spamInquiry_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerExternalReportWebApiHandler_spamInquiry_Args) =>
      RentalManagerExternalReportWebApiHandler_spamInquiry(args.getParams, httpClient),
  });
};

export interface RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Args {
  getParams: SpamInquiryForConversationParams;
}

export type RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Args
>;

/**
 * Report an inquiry as spam using conversationId for non authenticated users
 */
export const useRentalManagerExternalReportWebApiHandler_spamInquiryForConversation = ({
  httpClient,
  ...options
}: Omit<RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerExternalReportWebApiHandler_spamInquiryForConversation_Args) =>
      RentalManagerExternalReportWebApiHandler_spamInquiryForConversation(args.getParams, httpClient),
  });
};
